import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const SubscriptionsAndUsage = lazy(() =>
  import("@scenes/SubscriptionsAndUsage").then((module) => ({
    default: module.SubscriptionsAndUsage,
  }))
);

export const subscriptionAndUsageNRO: NavigationRoutingObject = {
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("subscription-and-usage", "Subscriptions and Usage"),
  Component: SubscriptionsAndUsage,
  componentFeatureFlippers: ["subscription_and_usage_nro_component"],
  getDeveloperNavigationAllowed: ({ hasPermission }) => {
    return hasPermission("appGroup", {
      permission: "viewBilling",
    });
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [
        t("subscription-and-usage-alt-keyword-1", "MAU"),
        t("subscription-and-usage-alt-keyword-2", "MUV"),
        t("subscription-and-usage-alt-keyword-3", "Email sends"),
        t("subscription-and-usage-alt-keyword-4", "Contract details"),
      ],
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
